import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="history-back"
// Sends the browser back one entry. Replaces `href="javascript:history.back()"`
// links, which a Content Security Policy without unsafe-inline blocks.
export default class extends Controller {
  back(event) {
    // The trigger is a link with no meaningful href, so suppress navigation.
    event.preventDefault();

    window.history.back();
  }
}
